import React from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../services/AuthService";

export default function Navbar({ setCurrentUser }) {
  const navigate = useNavigate();
  const currentUser = AuthService.getCurrentUser();

  const handleLogout = () => {
    AuthService.logout();
    setCurrentUser(null);
    navigate("/");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light mb-4 shadow-sm">
      <div className="container">
        <Link className="navbar-brand fw-bold" to="/home">
          W Medic
        </Link>

        {/* --- DUGME ZA HAMBURGER (Vidljivo samo na malim ekranima) --- */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarMainContent"
          aria-controls="navbarMainContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* --- SADRŽAJ KOJI SE SKUPLJA --- */}
        <div className="collapse navbar-collapse" id="navbarMainContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/staff">Zaposleni</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/pacijenti">Pacijenti</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/new-visit">Nova Poseta</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/waitlist">Čekaonica</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/StaffCalendar">Kalendar</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/izvestaj">Izveštaj</Link>
            </li>
          </ul>

          <div className="d-flex align-items-center">
            {/* Prikaz username-a */}
            {currentUser && (
              <span className="me-3 text-primary" style={{ fontWeight: "600" }}>
                👤 {currentUser.username}
              </span>
            )}

            <button 
              className="btn btn-outline-danger btn-sm" 
              onClick={handleLogout}
              style={{ borderRadius: "20px", padding: "5px 15px" }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}